<template>
  <div class="kw-timepicker" :class="{'kw-timeselect': type === 'timeselect'}">
    <KwDropdown :show="visible" @close="close">
      <KwInput
        v-model="value$"
        :readonly="true"
        :name="name"
        @click.self="visibleControl"
        :disabled="disabled"
        :class="className"
        ref="toggle"
        slot="toggle"
      />
      <div
        class="kw-timepicker-wrapper has-dropdown"
        :class="{'has-disabled': disabled}"
        ref="toggle"
        @blur="$emit('blur')"
        @click.self="visibleControl"
        @focus.prevent="$emit('blur')"
        slot="toggle"
      />
        <div>
          <slot name="hint" />
          <div
            class="kw-timepicker__select"
            v-if="type === 'timepicker'"
          >
            <KwTimepickerSelect
              :arrows="arrows"
              :scroll="scroll"
              :type="'hours'"
              :times="hours"
              :value="getHours(value$)"
              :selected-time="getHours(selectedVal)"
              @change="select"
              @close="close"
            />
            <KwTimepickerSelect
              :arrows="arrows"
              :scroll="scroll"
              :type="'minutes'"
              :times="minutes"
              :value="getMinutes(value$)"
              :selected-time="getMinutes(selectedVal)"
              @change="select"
              @close="close"
            />
          </div>
          <div
            class="kw-timepicker__select"
            v-if="type === 'timeselect'"
          >
            <KwTimepickerSelect
              :arrows="arrows"
              :scroll="scroll"
              :type="'time'"
              :times="times"
              :value="value$"
              :selected-time="selectedVal"
              @change="select"
              @close="close"
            />
          </div>
        </div>
    </KwDropdown>
  </div>
</template>
<script>
import KwInput from '@kiwitaxi/vue-components/dist/KwInput';
import KwDropdown from '@kiwitaxi/vue-components/dist/KwDropdown';
import KwTimepickerSelect from './KwTimepickerSelect.vue';

export default {
  props: {
    timeStart: String,
    timeEnd: {
      type: String,
      default: '23:59',
    },
    timeStep: String,
    timeFormat: {
      type: String,
      default: 'HH:mm',
    },
    minTime: String,
    maxTime: String,
    arrows: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'timepicker',
    },
    scroll: {
      type: Boolean,
      default: true,
    },
    options: Array,
    value: String,
    name: String,
    className: [String, Array, Object],
    validate: String,
    selectedTime: String,
    availableTime: Array,
  },
  data() {
    return {
      activeList: null,
      visible: false,
      startMinutes: '00',
      endMinutes: '59',
      selectedVal: this.value || this.selectedTime || '12:30',
      draggingY: null,
      incMinutes: [],
      excMinutes: [],
    };
  },
  components: {
    KwInput,
    KwDropdown,
    KwTimepickerSelect,
  },
  computed: {
    value$: {
      get() { return this.value; },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
    hoursSelected() {
      return this.selectedVal.split(':')[0];
    },
    minutesSelected() {
      return this.selectedVal.split(':')[1];
    },
    time() {
      const time = this.options;
      if (this.type === 'timeselect') {
        return time;
      }
      // no return statement
    },
    timeSelected() {
      return this.selectedVal;
    },
    timeActive() {
      if (this.value$) {
        return this.value$;
      }
      // no return statement
    },
    disabled() { return this.timeStart === 'disabled'; },
    minutes() {
      if (this.type !== 'timepicker') {
        return [];
      }
      let times = [];
      const step = this.timeStep ? this.timeStep.split(':')[1] : 1;
      const stepVal = Number(step) > 0 ? Number(step) : 1;
      for (let i = Number(this.startMinutes); i <= Number(this.endMinutes); i += stepVal) {
        if (i.toString().length < 2) {
          const twoDigTime = `0${i}`;
          if (!this.excMinutes.includes(twoDigTime)) {
            times.push(twoDigTime);
          }
        } else if (!this.excMinutes.includes(i.toString())) {
          times.push(i.toString());
        }
      }
      times = times.concat(this.incMinutes).sort();
      return times;
    },
    hours() {
      if (this.type !== 'timepicker') {
        return [];
      }
      const times = [];
      const step = this.timeStep ? Number(this.timeStep.split(':')[0]) : 1;
      const timeStart = this.timeStart ? Number(this.timeStart.split(':')[0]) : 0;
      const timeEnd = this.timeEnd ? Number(this.timeEnd.split(':')[0]) : 23;

      for (let i = timeStart; i <= timeEnd; i += step > 0 ? step : 1) {
        if (i.toString().length < 2) {
          const twoDigTime = `0${i}`;
          times.push(twoDigTime);
        } else {
          times.push(i.toString());
        }
      }
      return times;
    },
    times() {
      if (this.type !== 'timeselect') {
        return [];
      }
      let times = [];
      if (this.timeStart) {
        const startTime = new Date();
        const valueTime = new Date();
        const newTimes = [];
        startTime.setHours(Number(this.timeStart.split(':')[0]), Number(this.timeStart.split(':')[1]));
        for (let i = 0; i < this.options.length; i += 1) {
          valueTime.setHours(Number(this.options[i].split(':')[0]), Number(this.options[i].split(':')[1]));
          if (valueTime >= startTime) {
            newTimes.push(this.options[i]);
          }
        }
        times = newTimes;
      } else {
        times = this.options;
      }
      return times;
    },
  },
  methods: {
    select(data) {
      const startHour = this.timeStart ? this.timeStart.split(':')[0] : '00';
      const startMinutes = this.timeStart ? this.timeStart.split(':')[1] : '00';
      const endHour = this.timeEnd ? this.timeEnd.split(':')[0] : '24';
      const endMinutes = this.timeEnd ? this.timeEnd.split(':')[1] : '59';
      const { value, move, type } = data;

      if (this.value$) {
        if (type === 'hours') {
          if (value === startHour) {
            this.startMinutes = startMinutes;
            this.incMinutes = [];
            this.excMinutes = [];
            if (value === '00') {
              this.excMinutes = ['00'];
            }
          } else if (value === endHour) {
            this.endMinutes = endMinutes;
            this.incMinutes = [];
            this.excMinutes = [];
            if (value === '23') {
              this.incMinutes = ['59'];
            }
          } else {
            this.startMinutes = '00';
            this.endMinutes = '59';
            this.incMinutes = [];
            this.excMinutes = [];
          }

          if (value === startHour && this.minutesSelected < this.startMinutes) {
            this.value$ = `${value}:${this.startMinutes}`;
            this.selectedVal = `${value}:${this.startMinutes}`;
          } else if (value === endHour && this.minutesSelected > this.endMinutes) {
            this.value$ = `${value}:${this.endMinutes}`;
            this.selectedVal = `${value}:${this.endMinutes}`;
          } else {
            this.value$ = `${value}:${this.minutesSelected}`;
            this.selectedVal = `${value}:${this.minutesSelected}`;
          }
        } else if (type === 'minutes') {
          if (move) {
            this.selectedVal = `${this.hoursSelected}:${value}`;
          } else {
            this.value$ = `${this.hoursSelected}:${value}`;
            this.selectedVal = `${this.hoursSelected}:${value}`;
          }
        } else if (type === 'time') {
          this.value$ = value;
          this.selectedVal = value;
        }
      } else if (type === 'hours') {
        if (value === startHour) {
          this.startMinutes = startMinutes;
          this.incMinutes = [];
          this.excMinutes = [];
          if (value === '00') {
            this.excMinutes = ['00'];
          }
          if (move) {
            this.selectedVal = `${value}:${startMinutes}`;
          } else {
            this.value$ = `${value}:${startMinutes}`;
            this.selectedVal = `${value}:${startMinutes}`;
          }
        } else if (value === endHour) {
          this.endMinutes = endMinutes;
          this.incMinutes = [];
          this.excMinutes = [];
          if (value === '23') {
            this.incMinutes = ['59'];
          }
          if (move) {
            this.selectedVal = `${value}:00`;
          } else {
            this.value$ = `${value}:00`;
            this.selectedVal = `${value}:00`;
          }
        } else {
          this.startMinutes = '00';
          this.endMinutes = '59';
          this.incMinutes = [];
          this.excMinutes = [];
          if (move) {
            this.selectedVal = `${value}:${this.selectedVal.split(':')[1]}`;
          } else {
            this.value$ = `${value}:${this.selectedVal.split(':')[1]}`;
            this.selectedVal = `${value}:${this.selectedVal.split(':')[1]}`;
          }
        }
      } else if (type === 'minutes') {
        if (move) {
          this.selectedVal = `${this.hoursSelected}:${value}`;
        } else {
          this.value$ = `${this.hoursSelected}:${value}`;
          this.selectedVal = `${this.hoursSelected}:${value}`;
        }
      } else if (type === 'time') {
        this.value$ = value;
        this.selectedVal = value;
      }
    },
    close() {
      this.visible = false;
    },
    visibleControl() {
      if (this.timeStart !== 'disabled') {
        this.visible = !this.visible;
      }
    },
    getMinutes(time) {
      if (time) {
        return time.split(':')[1];
      }
      return time;
    },
    getHours(time) {
      if (time) {
        return time.split(':')[0];
      }
      return time;
    },
  },
  watch: {
    timeStart(newVal) {
      if (this.type === 'timepicker') {
        if (newVal) {
          [, this.startMinutes] = newVal.split(':');
          this.selectedVal = this.value;
        }
      }
    },
  },
  mounted() {
    const startHour = this.timeStart ? this.timeStart.split(':')[0] : '00';
    const selectedTime = this.selectedTime ? this.selectedTime.split(':')[0] : '12';
    const value = this.value ? this.value.split(':')[0] : selectedTime;
    const endHour = this.timeEnd ? this.timeEnd.split(':')[0] : '24';
    if (value === startHour) {
      this.incMinutes = [];
      this.excMinutes = [];
      if (value === '00') {
        this.excMinutes = ['00'];
      }
    } else if (value === endHour) {
      this.incMinutes = [];
      this.excMinutes = [];
      if (value === '23') {
        this.incMinutes = ['59'];
      }
    } else {
      this.incMinutes = [];
      this.excMinutes = [];
    }
  },
};
</script>
<style lang="scss">
.kw-input-group {
  .kw-timepicker {
    &:not(:last-child) {
      .kw-form-control {
        padding-right: rem(48);
      }
    }
  }
  &_has-icon {
    .kw-timepicker {
      &:not(:last-child) {
        .kw-form-control {
          padding-right: rem(48);
        }
      }
    }
  }
  &__icon {
    & + .kw-timepicker {
      .kw-form-control {
        padding-left: rem(48);
      }
    }
  }
}
.kw-timepicker {
  position: relative;
  @media (min-width: 768px) {
    width: 100%;
  }
  &-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
  }
  &__select {
    display: flex;
    position: relative;
    overflow-x: hidden;
    @include border-radius($border-radius-size, all);
    // margin: rem(-14);
    height: rem(152);
  }
  &__list {
    flex: 1 1 auto;
    text-align: center;
    height: 100%;
    position: relative;
    overflow: hidden;
    &:first-child {
      @include border-radius($border-radius-size, left);
    }
    &:last-child {
      @include border-radius($border-radius-size, right);
    }
    ul {
      list-style: none;
      text-align: center;
      top: 0;
      padding: 0px;
      transition: all .15s linear;
      @media (min-width: 768px){
        transition: all, .25s ease;
      }
    }
  }
  &__digit {
    display: block;
    height: rem(32);
    width: 100%;
    margin: auto;
    @include font-size(14);
    @include line-height(24, 10.5);
    cursor: pointer;
    color: $base-light;
    &:hover {
      @include font-weight(bold);
    }
    &.active {
      color: $base;
      @include font-weight(bold);
    }
    a {
      display: inline-block;
      width: 100%;
      height: 100%;
      color: inherit;
      text-decoration: none;
    }
  }
  &__arrow {
    appearance: none;
    border: none;
    box-shadow: none;
    outline: none;
    cursor: pointer;
    position: absolute;
    width: 100%;
    height: rem(32);
    margin: auto;
    @include font-size(24);
    line-height: 1;
    left: 0;
    right: 0;
    background: rgba(255,255,255, .95);
    z-index: 5;
    color: $base-lighter;
    transition: color, .25s ease;
    vertical-align: baseline;
    &:hover {
      color: $base
    }
    &_up {
      top: 0;
    }
    &_down {
      bottom: 0;
    }
  }
}
.kw-timeselect {
  .kw-timepicker__arrow {
    @include font-size(28);
    line-height: 0;
  }
}

.kw-timepicker,
.kw-timeselect {
  .kw-form-control {
    user-select: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UI/KwTimepicker/KwTimepicker.vue